import { PM_PROVIDERS } from 'common/constants/constants';
import { PmProviderTypes, PmViewConfigType } from './usePmViewer.types';

export const mapPmProviderToViewer = (
  pmProvider: PmProviderTypes
): PmViewConfigType => {
  const providerTypesMapper = {
    [PM_PROVIDERS.JIRA]: {
      ticket: { single: 'issue', plural: 'issues' },
      issueType: { single: 'issue type', plural: 'issue types' },
      label: { single: 'label', plural: 'labels' },
      storyPoint: { single: 'story point', plural: 'story points' },
      oldIssueParent1: { single: 'epic', plural: 'epics' },
      oldIssueParent2: { single: 'initiative', plural: 'initiatives' }
    },
    [PM_PROVIDERS.AZURE_BOARDS]: {
      ticket: { single: 'work item', plural: 'work items' },
      issueType: { single: 'work item type', plural: 'work items types' },
      label: { single: 'tag', plural: 'tags' },
      storyPoint: { single: 'story point', plural: 'story points' },
      oldIssueParent1: { single: 'feature', plural: 'features' },
      oldIssueParent2: { single: 'epic', plural: 'epics' }
    },
    [PM_PROVIDERS.CLUBHOUSE]: {
      ticket: { single: 'story', plural: 'stories' },
      issueType: { single: 'story type', plural: 'story types' },
      label: { single: 'label', plural: 'labels' },
      storyPoint: { single: 'estimate', plural: 'estimates' },
      oldIssueParent1: { single: 'epic', plural: 'epics' },
      oldIssueParent2: { single: 'initiative', plural: 'initiatives' }
    }
  };

  return (
    providerTypesMapper[pmProvider] || providerTypesMapper[PM_PROVIDERS.JIRA]
  );
};
